import { render, staticRenderFns } from "./threejs9.vue?vue&type=template&id=0fe46166&scoped=true"
import script from "./threejs9.vue?vue&type=script&lang=js"
export * from "./threejs9.vue?vue&type=script&lang=js"
import style0 from "./threejs9.vue?vue&type=style&index=0&id=0fe46166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe46166",
  null
  
)

export default component.exports